export default (initialPosition = 50, orientation = 'vertical') => ({
  sliderPosition: initialPosition,
  isDragging: false,
  orientation: orientation,

  init() {
    document.addEventListener('mousemove', (e) => this.drag(e))
    document.addEventListener('mouseup', () => this.stopDragging())
    document.addEventListener('touchmove', (e) => this.drag(e), { passive: false })
    document.addEventListener('touchend', () => this.stopDragging())

    this.$el._cleanup = () => {
      document.removeEventListener('mousemove', (e) => this.drag(e))
      document.removeEventListener('mouseup', () => this.stopDragging())
      document.removeEventListener('touchmove', (e) => this.drag(e))
      document.removeEventListener('touchend', () => this.stopDragging())
    }
  },

  startDragging(event) {
    this.isDragging = true
    event.preventDefault()
  },

  stopDragging() {
    this.isDragging = false
  },

  drag(event) {
    if (!this.isDragging) return

    const container = this.$el
    const rect = container.getBoundingClientRect()

    let position

    if (this.orientation === 'vertical') {
      const clientX = event.touches ? event.touches[0].clientX : event.clientX
      position = ((clientX - rect.left) / rect.width) * 100
    } else {
      const clientY = event.touches ? event.touches[0].clientY : event.clientY
      position = ((clientY - rect.top) / rect.height) * 100
    }

    this.sliderPosition = Math.max(0, Math.min(100, position))

    if (event.touches) {
      event.preventDefault()
    }
  },

  destroy() {
    if (this.$el._cleanup) {
      this.$el._cleanup()
    }
  }
})
